import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormSelect from '../form/FormSelect';
import { fleetDepartmentOptions } from '../../libs/common';

const driverGroupStart = fleetDepartmentOptions.findIndex((o) => o.isGroup === 'Driver');
const driverOptions = fleetDepartmentOptions.slice(driverGroupStart);

class FleetPicker extends PureComponent {
	render() {
		return <FormSelect {...this.props} options={driverOptions} />;
	}
}

FleetPicker.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	classes: PropTypes.object,
	helpText: PropTypes.string,
};

FleetPicker.defaultProps = {
	label: 'Ticket Schema',
};

export default FleetPicker;
